import { observable } from '@legendapp/state';
import Decimal from 'decimal.js';
import { configurationState$ } from './configuration.state';

export type WalletTransaction = {
  win: boolean;
  winId: string;
  betId: string;
};

type WalletState = {
  balance: number;
  transactions: WalletTransaction[];
  setBalance: (balance: number) => void;
};

export const walletState$ = observable<WalletState>({
  balance: 0,
  transactions: [],
  setBalance: (balance: number) => {
    const coefficient = configurationState$.coeficient.peek();
    // Prevent division by zero
    if (coefficient === 0) {
      console.error('Cannot set balance: coefficient is 0');
      walletState$.balance.set(0);
      return;
    }
    walletState$.balance.set(new Decimal(balance).div(coefficient).toNumber());
  },
});
